/* Interactions only. Native Shopify forms own purchasing; no invented cart data. */
(() => {
  function setup(root = document) {
    root.querySelectorAll('[data-som-gift]').forEach(section => {
      if (section.dataset.somReady) return;
      section.dataset.somReady = 'true';
      section.querySelectorAll('[data-som-gift-choice]').forEach(button => button.addEventListener('click', () => {
        section.querySelectorAll('[data-som-gift-panel]').forEach(panel => { panel.hidden = panel.dataset.somGiftPanel !== button.dataset.somGiftChoice; });
        section.querySelectorAll('[data-som-gift-choice]').forEach(choice => choice.setAttribute('aria-pressed', String(choice === button)));
      }));
    });
    root.querySelectorAll('[data-som-product]').forEach(section => {
      if (section.dataset.somReady) return;
      section.dataset.somReady = 'true';
      const slides = [...section.querySelectorAll('[data-som-slide]')];
      const thumbs = [...section.querySelectorAll('[data-som-thumb]')];
      let activePhoto = Math.max(0, slides.findIndex(slide => !slide.hidden));
      const showPhoto = index => {
        if (!slides.length) return;
        activePhoto = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== activePhoto; });
        thumbs.forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb.dataset.somThumb === slides[activePhoto].dataset.somSlide)));
        const counter = section.querySelector('[data-som-gallery-count]');
        if (counter) counter.textContent = `${activePhoto + 1} / ${slides.length}`;
      };
      thumbs.forEach(button => button.addEventListener('click', () => showPhoto(slides.findIndex(slide => slide.dataset.somSlide === button.dataset.somThumb))));
      section.querySelector('[data-som-gallery-prev]')?.addEventListener('click', () => showPhoto(activePhoto - 1));
      section.querySelector('[data-som-gallery-next]')?.addEventListener('click', () => showPhoto(activePhoto + 1));
      const gallery = section.querySelector('[data-som-gallery]');
      gallery?.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const index = event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : activePhoto + (event.key === 'ArrowRight' ? 1 : -1);
        showPhoto(index);
        thumbs[activePhoto]?.focus();
      });
      const picker = section.querySelector('[data-som-variant]');
      const mainButton = section.querySelector('[data-som-add]');
      const sticky = section.querySelector('[data-som-sticky]');
      const update = () => {
        if (!picker) return;
        const option = picker.options[picker.selectedIndex];
        const currency = window.Shopify?.currency?.active || 'PLN';
        const money = value => new Intl.NumberFormat(document.documentElement.lang || 'pl-PL', {style: 'currency', currency}).format(value / 100);
        const amount = Number(option.dataset.price);
        const count = Number(section.querySelector('[name="quantity"]:checked')?.value || 1);
        section.querySelector('[data-som-price]').textContent = option.dataset.money;
        section.querySelectorAll('[data-som-total]').forEach(total => { total.textContent = money(amount * Number(total.dataset.somTotal)); });
        section.querySelectorAll('[data-som-selected-total]').forEach(total => { total.textContent = `${count} szt. · ${money(amount * count)}`; });
        section.querySelectorAll('[data-som-add],[data-som-sticky-add]').forEach(button => {
          button.disabled = option.dataset.available !== 'true';
          button.textContent = button.disabled ? 'Obecnie niedostępna' : 'Dodaj do koszyka ↗';
        });
      };
      picker?.addEventListener('change', update);
      section.querySelectorAll('[name="quantity"]').forEach(input => input.addEventListener('change', update));
      update();
      if (sticky && mainButton && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          const entry = entries[0];
          sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
        });
        observer.observe(mainButton);
        section.addEventListener('som:destroy', () => observer.disconnect(), {once:true});
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup()); else setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-som-product]').forEach(section => section.dispatchEvent(new Event('som:destroy'))));
})();
